import { Box, Typography } from "@mui/material";
import { isObject } from "formik";
import useColors from "../../../../api/hooks/useColors";
import CustomToolTip from "../../../../components/CustomTooltip";
import {
  getPrettyDate,
  getPrettyDateTime,
  useLocalTime,
} from "../../../../utils/timestamp";

const TextIntegrationStyle = ({
  title,
  value,
  onClick = null,
  style = null,
  tooltipTitle = null,
  onlyDate = false,
}) => {
  const colors = useColors();
  const showLocalTime = useLocalTime();
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "flex-start",
        justifyItems: "center",
        gap: 1,
      }}
    >
      <Typography variant="overline" fontWeight={"500"}>
        {title}
      </Typography>

      {isObject(value) && value.hasOwnProperty("timestamp_utc") ? (
        <Typography
          variant="caption"
          fontSize={"12px"}
          color={colors.text_secondary}
        >
          {onlyDate
            ? getPrettyDate(value?.timestamp_utc, showLocalTime)
            : getPrettyDateTime(value?.timestamp_utc, showLocalTime)}
        </Typography>
      ) : tooltipTitle ? (
        <CustomToolTip title={tooltipTitle}>
          <Typography
            variant="caption"
            fontSize={"12px"}
            color={colors.text_secondary}
            {...(onClick ? { onClick: onClick } : {})}
            style={{ wordBreak: "break-all", ...(style || {}) }}
          >
            {value}
          </Typography>
        </CustomToolTip>
      ) : (
        <Typography
          variant="caption"
          color={colors.text_secondary}
          {...(onClick ? { onClick: onClick } : {})}
          style={{ wordBreak: "break-all", ...(style || {}) }}
        >
          {value}
        </Typography>
      )}
    </Box>
  );
};

export default TextIntegrationStyle;
